import {formsApiHostName} from "../endpoint";
import {defaultHeaders} from "../headers";

export const deleteFormAttachment = async (Key) => {
  try {
    const result = await fetch(
      `${formsApiHostName}/form/attachment/delete`,
      {
        method: "PUT",
        headers: {
          ...defaultHeaders,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify({Key}),
      }
    );
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
